module.exports = __webpack_public_path__ + "static/scale-model-of-tait-cummins-sports-complex-in-cedar-rapids-iowa-bea1a5cd4f9e998be82510430732b3df.png";